<template>
  <div>
    <managementList
      @switchBtnNum="switchBtn($event)"
      v-if="switchBtnNum == 1"
    ></managementList>
    <managementMpa
      @switchBtnNum="switchBtn($event)"
      v-if="switchBtnNum == 2"
    ></managementMpa>
  </div>
</template>

<script>
import managementList from "../../components/management/managementList.vue";
import managementMpa from "../../components/management/managementMpa.vue";
export default {
  data() {
    return {
      switchBtnNum: "1"
    };
  },
  components: {
    managementList,
    managementMpa
  },
  methods: {
    switchBtn(e) {
      console.log(e);
      this.switchBtnNum = e;
    }
  }
};
</script>

<style lang="less" scoped></style>
